import SwitchSelect from '@/global/components/SwitchSelect'
import { useAdminOutletContext } from '@/routes/paths/admin'
import { TabContext, TabPanel } from '@mui/lab'
import ContentGuide from 'global/guides/ContentGuide'
import { useState } from 'react'
import {
    Outlet,
    useNavigate,
    useOutletContext,
    useParams,
} from 'react-router-dom'
import {
    clientes,
    Treinamento,
    treinamentos as treinamentosApi,
} from 'service/api'
import SelectCliente from '../SelectCliente'
import GridDesenvolvimento from './Cobrancas/Desenvolvimento'
import GridTreinamentos from './Cobrancas/Treinamentos'

enum Aba {
    TREINAMENTOS = 'Treinamentos',
    DESENVOLVIMENTO = 'Desenvolvimento',
}

const ABAS = [
    { value: Aba.TREINAMENTOS, label: 'Treinamentos' },
    { value: Aba.DESENVOLVIMENTO, label: 'Desenvolvimento' },
] as const

export default function CobrancasClientePage() {
    const navigate = useNavigate()
    const { clientes: clientesAdmin = [] } = useAdminOutletContext()
    const { clienteId } = useParams()
    const [aba, setAba] = useState<Aba>(Aba.TREINAMENTOS)

    const { data: cliente } = clientes.useFetchById(Number(clienteId), {
        enabled: !isNaN(Number(clienteId)),
    })

    const { data = [], isLoading } = treinamentosApi.useFetch<Treinamento[]>({
        queryParams: { clienteId: String(clienteId) },
        enabled: Boolean(clienteId),
    })

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={[
                        'Administração',
                        {
                            title: 'Clientes',
                            to: '/administracao/clientes',
                        },
                        'Cobranças',
                        aba,
                    ]}
                >
                    <SwitchSelect
                        label="Aba"
                        className="w-[200px]"
                        value={aba}
                        options={ABAS}
                        onChange={setAba}
                    />
                    <SelectCliente
                        className="w-[400px]"
                        clienteId={Number(clienteId)}
                        clientes={clientesAdmin.concat(cliente!)}
                        onChange={newClienteId =>
                            navigate(
                                `/administracao/clientes/${newClienteId}/cobrancas`,
                            )
                        }
                    />
                </ContentGuide.Header>
                <TabContext value={aba}>
                    <TabPanel
                        value={Aba.TREINAMENTOS}
                        className="size-full overflow-hidden p-0"
                    >
                        <GridTreinamentos
                            data={data}
                            isLoading={isLoading}
                            criadoEm={cliente?.createdAt}
                        />
                    </TabPanel>
                    <TabPanel
                        value={Aba.DESENVOLVIMENTO}
                        className="size-full overflow-hidden p-0"
                    >
                        <GridDesenvolvimento
                            clienteId={Number(clienteId)}
                            criadoEm={cliente?.createdAt}
                        />
                    </TabPanel>
                </TabContext>
            </ContentGuide.Card>
            <Outlet context={{ data, clienteId: Number(clienteId) }} />
        </ContentGuide>
    )
}

export function useTreinamentosOutletContext() {
    return useOutletContext<{ data: Treinamento[]; clienteId: number }>()
}
